/**
 * /app/trusts/$id/assets — §16 recognised-assets tab (route shell).
 *
 * Screen impl in `./assets-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * A deep trust sub-tab (assets table + status badges + assign dialog + the
 * trust→company→asset ownership chain), not a first-paint route, so the body
 * leaves the entry bundle (200 kB gzip budget). Same shell+screen pattern as
 * the sibling `./portfolios.tsx` / `./documents.tsx` tabs. The committed
 * routeTree.gen.ts imports only `Route` from here, so no plugin regen is needed.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/assets')({
  component: lazyRouteComponent(() => import('./assets-screen'), 'AssetsScreen'),
});
